import { Card, Button, Row, Col, Badge, Dropdown } from "react-bootstrap";
import { Pencil, MoreVertical } from "lucide-react";
import { RiDeleteBinLine } from "react-icons/ri";
import { BsLock, BsSlashCircle, BsCheckCircle } from "react-icons/bs";
import { Tabs, Tab } from "react-bootstrap";
import { useEffect, useState, useContext, useCallback } from "react";
import AccountEditManagement from "./AccountEditManagment";
import { useParams } from "react-router-dom";
import { DeActivateAccountUser, DeleteAccountUser, getAccountUserProfile } from "../../../services/adminApiService/accountManagementApi/AccountManagementApiService";
import { formatDateTime } from "../../../utils/dateTimeFormate";
import { AccountManagementContext } from "../../../context/AccountManagementContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AccountRestPassword from "./AccountRestPassword";
import AccountRolePermission from "./AccountRole&Permission";
import { HiUserCircle } from "react-icons/hi2";
import { useDeleteHandler } from "../../../hooks/useDeleteHandler";
import { AuthContext } from "../../../context/AuthContext";
export default function AccountProfileManagement() {

    const { handleDelete } = useDeleteHandler();
    const { fetchUserAccountManagementList, fetchDeleteAccountuser, fetchVerificationList, accountProfileData, getAccountUserCount } = useContext(AccountManagementContext);
    const loginDetails = JSON.parse(localStorage.getItem("login_Details"));
    const userLevelId = loginDetails?.user?.user_level;
    const { id } = useParams();
    const [showEdit, setShowEdit] = useState();
    const navigate = useNavigate();
    const isActive = accountProfileData?.activated === true;
    const [showResetModal, setShowResetModal] = useState(false);


    useEffect(() => {
        fetchVerificationList(id);
    }, []);
    // const deleteHandler = (id) => {
    //     fetchDeleteAccountuser(id, "profile");
    // };

    const deleteHandler = (id) => {
        handleDelete({
            deleteApi: () => DeleteAccountUser(id),
            refreshListApi: () => {
                fetchUserAccountManagementList();
                getAccountUserCount();
            },
            successMsg: "User Role deleted successfully",
            redirectPath: "/account/accountmanagement",
        });
    };

    // const fetchToggleAccountStatus = useCallback(
    //     async (id, activated, profile) => {
    //         const isDeactivate = accountProfileData?.action_label === "Deactivate Account";

    //         const result = await Swal.fire({
    //             title: "Are you sure?",
    //             text: isDeactivate
    //                 ? "Do you want to deactivate this account?"
    //                 : "Do you want to activate this account?",
    //             icon: "warning",
    //             showCancelButton: true,
    //             confirmButtonColor: isDeactivate ? "#d33" : "#198754",
    //             cancelButtonColor: "#6c757d",
    //             confirmButtonText: isDeactivate
    //                 ? "Yes, deactivate"
    //                 : "Yes, activate",
    //         });

    //         if (!result.isConfirmed) return;

    //         try {
    //             const payload = {
    //                 activated, // ✅ 0 or 1
    //             };

    //             await DeActivateAccountUser(id, payload);
    //             await getAccountUserCount();
    //             await Swal.fire({
    //                 icon: "success",
    //                 title: isDeactivate ? "Deactivated!" : "Activated!",
    //                 text: response?.data?.message, // 👈 backend message
    //                 timer: 1500,
    //                 showConfirmButton: false,
    //             });

    //             if (profile) {
    //                 navigate("/account/accountmanagement");
    //             }

    //             fetchUserAccountManagementList();
    //         } catch (error) {
    //             Swal.fire({
    //                 icon: "error",
    //                 title: "Error",
    //                 text: isDeactivate
    //                     ? "Failed to deactivate account"
    //                     : "Failed to activate account",
    //             });
    //         }
    //     },
    //     [fetchUserAccountManagementList]
    // );

    const fetchToggleAccountStatus = useCallback(
        async (id, activated, profile) => {
            const isDeactivate =
                accountProfileData?.action_label === "Deactivate Account";

            const result = await Swal.fire({
                title: "Are you sure?",
                text: isDeactivate
                    ? "Do you want to deactivate this account?"
                    : "Do you want to activate this account?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: isDeactivate ? "#d33" : "#198754",
                cancelButtonColor: "#6c757d",
                confirmButtonText: isDeactivate
                    ? "Yes, deactivate"
                    : "Yes, activate",
            });

            if (!result.isConfirmed) return;

            try {
                const activateValue = isDeactivate ? 0 : 1;
                const payload = {
                    activated: activateValue,
                };

                const response = await DeActivateAccountUser(id, payload); // ✅ FIX

                await getAccountUserCount();

                await Swal.fire({
                    icon: "success",
                    title: isDeactivate ? "Deactivated!" : "Activated!",
                    text: response?.data?.message, // ✅ backend message
                    timer: 1500,
                    showConfirmButton: false,
                });

                if (profile) {
                    navigate("/account/accountmanagement");
                }

                fetchUserAccountManagementList();
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: isDeactivate
                        ? "Failed to deactivate account"
                        : "Failed to activate account",
                });
            }
        },
        [fetchUserAccountManagementList, accountProfileData]
    );

    return (
        <>
            <div className="p-4 min-vh-100 account-profile-card">
                {/* Header */}
                <Card className="mb-4 shadow-sm rounded-4">
                    <Card.Body
                        className="d-flex justify-content-between align-items-center rounded-4"
                        style={{ background: "linear-gradient(90deg, #ede9fe, #e0e7ff)" }}
                    >
                        <div className="d-flex align-items-center gap-3">
                            {accountProfileData?.image_url ? (
                                <img
                                    src={accountProfileData.image_url}
                                    alt="profile"
                                    className="rounded-circle"
                                    width={64}
                                    height={64}
                                />
                            ) : (
                                <HiUserCircle size={64} className="text-primary" />
                            )}
                            <div>
                                <Badge
                                    bg="white"
                                    text="primary"
                                    className="mb-1 border"
                                >
                                    #{accountProfileData?.id}
                                </Badge>
                                <h5 className="mb-0 fw-semibold">{accountProfileData?.name}</h5>
                            </div>
                        </div>

                        <div className="d-flex gap-2">
                            <Button bg="#fffff" size="sm" onClick={() => setShowEdit(true)}>
                                <Pencil size={14} className="me-1" /> Edit Profile
                            </Button>
                           {userLevelId !== 3 && (
                            <Dropdown align="end">
                                <Dropdown.Toggle size="sm">
                                    <MoreVertical size={16} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => setShowResetModal(true)}>
                                        <BsLock className="me-2" /> Reset Password
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() =>
                                            fetchToggleAccountStatus(
                                                accountProfileData?.id,
                                                isActive ? 0 : 1, // 👈 SEND 0 / 1
                                                true
                                            )
                                        }
                                    >
                                        {/* {isActive ? (
                                            <>
                                                <BsSlashCircle className="me-2 text-danger" />
                                                Deactivate Account
                                            </>
                                        ) : (
                                            <>
                                                <BsCheckCircle className="me-2 text-success" />
                                                Activate Account
                                            </>
                                        )} */}
                                        {accountProfileData?.action_label === "Deactivate Account" ? (
                                            <>
                                                <BsSlashCircle className="me-2 " />
                                                {accountProfileData?.action_label}
                                            </>
                                        ) : (
                                            <>
                                                <BsCheckCircle className="me-2 text-success" />
                                                {accountProfileData?.action_label}
                                            </>
                                        )}
                                    </Dropdown.Item>



                                    <Dropdown.Divider />
                                    <Dropdown.Item className="text-danger" onClick={() => deleteHandler(id)}>
                                        <RiDeleteBinLine className="me-2" /> Delete Account
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                           )}
                        </div>
                    </Card.Body>
                </Card>


                <Card>
                    <Tabs
                        defaultActiveKey="overview"
                        className="custom-tabs mb"
                        mountOnEnter
                        unmountOnExit
                    >
                        {/* ================= OVERVIEW TAB ================= */}
                        <Tab eventKey="overview" title="Overview">
                            <div className="p-2">
                                <Row className="g-4 account-tab-container mt-3  px-2">

                                    {/* Personal Details */}
                                    <Col md={6} className="px-3">
                                        <Card className="detail-card   h-100 ">
                                            <Card.Body>
                                                <h6 className="sections-title">Personal Details</h6>

                                                <Row className="detail-grid mx-1">
                                                    <Col xs={6} className="">
                                                        <p className="label">Full Name</p>
                                                        <p className="value">{accountProfileData?.name}</p>
                                                    </Col>

                                                    <Col xs={6}>
                                                        <p className="label">Father's Name</p>
                                                        <p className="value">{accountProfileData?.father_name || "N/A"}</p>
                                                    </Col>

                                                    <Col xs={6}>
                                                        <p className="label">Gender</p>
                                                        <p className="value">{accountProfileData?.gender || "N/A"}</p>
                                                    </Col>

                                                    <Col xs={6}>
                                                        <p className="label">Date of Birth</p>
                                                        <p className="value">{accountProfileData?.dob || "N/A"}</p>
                                                    </Col>

                                                    <Col xs={6}>
                                                        <p className="label">Email</p>
                                                        <p className="value">{accountProfileData?.email}</p>
                                                    </Col>

                                                    <Col xs={6}>
                                                        <p className="label">Mobile Number</p>
                                                        <p className="value">{accountProfileData?.phone}</p>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    {/* Address */}
                                    <Col md={6} className="px-2">
                                        <Card className="detail-card   h-100 ">
                                            <Card.Body>
                                                <h6 className="section-title">Address</h6>

                                                <Row className="detail-grid mx-1">
                                                    <Col xs={6}>
                                                        <p className="label">Country</p>
                                                        <p className="value">{accountProfileData?.country_name || "India"}</p>
                                                    </Col>

                                                    <Col xs={6}>
                                                        <p className="label">State</p>
                                                        <p className="value">{accountProfileData?.state_name}</p>
                                                    </Col>

                                                    <Col xs={6}>
                                                        <p className="label">City</p>
                                                        <p className="value">{accountProfileData?.district_name}</p>
                                                    </Col>

                                                    <Col xs={6}>
                                                        <p className="label">Pin Code</p>
                                                        <p className="value">{accountProfileData?.pincode || "N/A"}</p>
                                                    </Col>

                                                    {/* <Col xs={12}>
                                                        <p className="label">Address</p>
                                                        <p className="value">
                                                            {accountProfileData?.address || "N/A"}
                                                        </p>
                                                    </Col> */}
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col md={6} className="mb-4 px-3">
                                        <Card className="detail-card mx-1 h-100">
                                            <Card.Body>
                                                <h6 className="section-title">Account Summary</h6>

                                                <Row className="detail-grid mx-1">
                                                    <Col xs={6}>
                                                        <p className="label">Account Status</p>
                                                        <div className="mb-2">
                                                            <span className="status-pill active">{accountProfileData?.activated === "1" ? (
                                                                <span className="status-btn active">Active</span>
                                                            ) : (
                                                                <span className="status-btn inactive">Inactive</span>
                                                            )}</span>
                                                        </div>

                                                    </Col>

                                                    {/* <Col xs={6}>
                                                            <p className="label">Last Login</p>
                                                            <p className="value">{accountProfileData?.last_attempt_time || "N/A"}</p>
                                                        </Col> */}

                                                    <Col xs={6}>
                                                        <p className="label">Last Password Reset</p>
                                                        <p className="value">{accountProfileData?.last_password_reset_display}</p>
                                                    </Col>

                                                    <Col xs={6}>
                                                        <p className="label">Joined On</p>
                                                        <p className="value">
                                                            {formatDateTime(accountProfileData?.created_at)}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>


                                </Row>
                            </div>


                        </Tab>


                        {/* ================= ROLE & PERMISSIONS TAB ================= */}
                        <Tab eventKey="roles" title="Role & Permissions">
                            <AccountRolePermission accountProfileData={accountProfileData} />
                        </Tab>

                    </Tabs>
                </Card>

                <AccountEditManagement show={showEdit}
                    onHide={() => setShowEdit(false)} />

                <AccountRestPassword showResetModal={showResetModal}
                    setShowResetModal={setShowResetModal} />
            </div>
        </>
    );
}
